module.exports = __webpack_public_path__ + "static/media/award.87214206.svg";